import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Political PR",
  "Assembly Elections",
  "Corporate Communications",
  "Data Analysis",
  "Local Body Strategy",
  "Media Management",
  "Page Handling",
  "Institutional Affairs",
  "Crisis Response",
];

const EditorialMarquee = ({ reverse = false }) => {
  return (
    <div
      className="kicker bg-white py-6 md:py-8 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={42} gradient={false} direction={reverse ? "right" : "left"}>
        {items.concat(items).map((it, i) => (
          <span key={i} className="marquee-text">
            {it}
            <span className="marquee-dot" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
